import React from 'react';
import { Table, Pagination, Typography } from 'antd';
import { useTable } from './hooks/useTable';
import { getStored } from '../../store/useLocalStored';
const { Text } = Typography;

function renderStripe(record, index) {
  if (index % 2 == 0) {
    return getStored('theme') === 'dark' ? 'stripe-row-black' : 'stripe-row-grey';
  }
}

const TableComponent = ({
  loading,
  columns,
  dataSource,
  withCustomPagination,
  hasPagination,
  getApi,
  rowSelection,
  rowKey,
  components,
  expandable,
  rowClassName,
  useTableObject = useTable(),
  onChange,
  ...rest
}) => {
  const { setCurrentPage, onShowSizeChange, pageSize, defaultPageSize, sizePageOptions, current } =
    useTableObject;

  const onPaginationChange = (page, pageSizeNumber) => {
    if (page !== current) {
      setCurrentPage(page);
    }

    if (typeof getApi === 'function') {
      getApi(page, pageSizeNumber);
    }
  };

  // ต่อ class ของหน้าที่เรียกใช้เข้ากับ zebra stripe เดิม ไม่ทับกัน
  const composeRowClassName = (record, index) => {
    const extra = typeof rowClassName === 'function' ? rowClassName(record, index) : rowClassName;
    return [renderStripe(record, index), extra].filter(Boolean).join(' ');
  };

  const propsTable = {
    onShowSizeChange,
    pageSize: pageSize,
    pageSizeOptions: sizePageOptions,
    showTotal: (total) => `${total} รายการ`,
    defaultPageSize: defaultPageSize,
    defaultCurrent: 1,
  };

  // ตารางว่างจะหดคอลัมน์ลงจนหัวตารางตัดคำเป็นแนวตั้ง เพราะ 'max-content' วัดจาก
  // เนื้อหาจริง ซึ่งพอไม่มีแถวก็เหลือแค่ข้อความหัวคอลัมน์
  // รวมความกว้างที่แต่ละคอลัมน์ประกาศไว้มาเป็น scroll.x แทน ตารางจะกว้างเท่ากัน
  // ทั้งตอนมีและไม่มีข้อมูล
  const sumColumnWidth = (cols) =>
    (cols || []).reduce((total, column) => {
      if (column?.children?.length) {
        return total + sumColumnWidth(column.children);
      }
      return total + (typeof column?.width === 'number' ? column.width : 0);
    }, 0);

  const declaredWidth = sumColumnWidth(columns);
  const defaultScroll = {
    x: declaredWidth > 0 ? declaredWidth : 'max-content',
    y: '100%',
  };

  return (
    <>
      <Table
        components={components}
        rowKey={rowKey || 'key'}
        rowClassName={composeRowClassName}
        rowSelection={
          rowSelection && {
            ...rowSelection,
            selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
          }
        }
        columns={columns}
        dataSource={dataSource}
        scroll={{ ...defaultScroll, ...rest.scroll }}
        pagination={
          hasPagination &&
          !withCustomPagination && {
            total: dataSource?.length || 0,
            showSizeChanger: dataSource?.length > 10,
            ...propsTable,
          }
        }
        summary={() => SummaryTable(rest.summary)}
        expandable={expandable}
        loading={loading}
        onChange={onChange}
      />
      {hasPagination && withCustomPagination && (
        <div style={{ textAlign: 'end', margin: '15px 0' }}>
          <Pagination
            total={rest.total}
            onChange={onPaginationChange}
            current={current}
            {...propsTable}
          />
        </div>
      )}
    </>
  );
};

const SummaryTable = (summary) => {
  if (!summary || JSON.stringify(summary) === '{}') {
    return null;
  }

  const { rowSum, dataSum } = summary;

  return (
    <Table.Summary fixed>
      {rowSum.map((row) => (
        <Table.Summary.Row key={`sumRow_${row.rowNum}`} {...row}>
          {row.columnSum.map((col, i) => (
            <Table.Summary.Cell key={`column_${col.title}`} index={i} colSpan={col.colSpan}>
              <Text style={col.style}>{col.title || (dataSum && dataSum[col.refColumn]) || 0}</Text>
            </Table.Summary.Cell>
          ))}
        </Table.Summary.Row>
      ))}
    </Table.Summary>
  );
};

export default TableComponent;
